import React from "react";
import Fieldset from "../../common/Fieldset";
import AdresFormItem from "./AdresFormItem";
import CheckBoxWithChild from "../../common/CheckBoxWithChild";
import PropTypes, { object } from "prop-types";
const AanvraagAdresFormItem = (props) => {

    const {
        onChange,
        onChangeAanvraagAdres,
        model,
        errors
    } = props;

    return (
        <Fieldset title="Aanvraagadres vestiging">
            <CheckBoxWithChild
                name="isNotIdem"
                label="Aanvraagadres vestiging is niet hetzelfde aan hoofdzetel"
                value={model.isNotIdem}
                onChange={onChange}
                child={
                    <AdresFormItem
                        onChange={onChangeAanvraagAdres}
                        model={model.adres}
                        errors={errors["vestigingAdres"]}
                    />
                }
            />
        </Fieldset>
    );
};

AanvraagAdresFormItem.propTypes = {
    onChange: PropTypes.func,
    onChangeAanvraagAdres: PropTypes.func,
    model: PropTypes.object,
    errors: PropTypes.array
};

export default AanvraagAdresFormItem;